import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getPageTitle } from "~/locationMaps/pageMappings";

/** Keeps `document.title` in sync with the active route via the page-mapping registry. */
const usePageTitle = (): void => {
	const { pathname } = useLocation();

	useEffect(() => {
		document.title = getPageTitle(pathname);
	}, [pathname]);
};

export default usePageTitle;
